/* AMATO ATTIRE — MAIN JS */
(function () {
  'use strict';

  // ===== ANNOUNCEMENT BAR =====
  const announcements = ['AUTHENTICITY GUARANTEED', 'BRAND NEW & PRE-OWNED', 'NEXT DAY DELIVERY'];
  let annIdx = 0;
  const annEl = document.getElementById('announcement-text');
  if (annEl) {
    setInterval(() => {
      annIdx = (annIdx + 1) % announcements.length;
      annEl.style.opacity = '0';
      setTimeout(() => {
        annEl.textContent = announcements[annIdx];
        annEl.style.opacity = '1';
      }, 300);
    }, 3000);
    annEl.style.transition = 'opacity 0.3s';
  }


  // ===== HEADER SCROLL =====
  const siteHeader = document.getElementById('site-header');
  if (siteHeader) {
    function onScroll() {
      siteHeader.classList.toggle('scrolled', window.scrollY > 10);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ===== HERO SLIDESHOW =====
  const heroSlides = document.querySelectorAll('.hero-slide');
  if (heroSlides.length > 1) {
    let heroIdx = 0;
    setInterval(() => {
      heroSlides[heroIdx].classList.remove('active');
      heroIdx = (heroIdx + 1) % heroSlides.length;
      heroSlides[heroIdx].classList.add('active');
    }, 5000);
  }

  // ===== MOBILE MENU =====
  const menuToggle = document.getElementById('menu-toggle');
  const menuClose = document.getElementById('menu-close');
  const mobileMenu = document.getElementById('mobile-menu');
  const menuOverlay = document.getElementById('menu-overlay');

  function openMenu() {
    mobileMenu && mobileMenu.classList.add('open');
    menuOverlay && menuOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    mobileMenu && mobileMenu.classList.remove('open');
    menuOverlay && menuOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }
  menuToggle && menuToggle.addEventListener('click', openMenu);
  menuClose && menuClose.addEventListener('click', closeMenu);
  menuOverlay && menuOverlay.addEventListener('click', closeMenu);

  // ===== MOBILE NAV DROPDOWNS =====
  document.querySelectorAll('.mobile-nav-toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      var dropdown = this.nextElementSibling;
      if (dropdown) dropdown.classList.toggle('open', !expanded);
    });
  });

  // ===== SEARCH BAR =====
  const searchToggle = document.getElementById('search-toggle');
  const searchBar = document.getElementById('search-bar');
  searchToggle && searchToggle.addEventListener('click', () => {
    searchBar && searchBar.classList.toggle('active');
    if (searchBar && searchBar.classList.contains('active')) {
      const input = searchBar.querySelector('input');
      input && setTimeout(() => input.focus(), 50);
    }
  });

  // ===== CATEGORY CAROUSEL (Swiper bundle — all modules pre-registered) =====
  let catSwiperInstance = null;

  function initCategorySwiper() {
    if (typeof Swiper === 'undefined') return;
    const catEl = document.querySelector('.category-swiper');
    if (!catEl) return;
    if (catSwiperInstance) { try { catSwiperInstance.destroy(true, true); } catch(e) {} catSwiperInstance = null; }
    const slideCount = catEl.querySelectorAll('.swiper-slide').length;
    catSwiperInstance = new Swiper(catEl, {
      effect: 'coverflow',
      centeredSlides: true,
      loop: false,
      speed: 600,
      initialSlide: Math.floor(slideCount / 2),
      grabCursor: true,
      coverflowEffect: { rotate: 16, stretch: 0, depth: 200, modifier: 1, slideShadows: false },
      breakpoints: {
        320:  { slidesPerView: 2 },
        768:  { slidesPerView: 3 },
        1024: { slidesPerView: 5 },
      },
    });
  }

  initCategorySwiper();

  // Reinitialize when the theme editor reloads the section or changes settings
  document.addEventListener('shopify:section:load', function(e) {
    if (e.target.querySelector('.category-swiper')) initCategorySwiper();
  });
  document.addEventListener('shopify:section:select', function(e) {
    if (document.querySelector('.category-swiper')) initCategorySwiper();
  });
  document.addEventListener('shopify:block:select', function(e) {
    if (document.querySelector('.category-swiper')) initCategorySwiper();
  });
  document.addEventListener('shopify:block:deselect', function(e) {
    if (document.querySelector('.category-swiper')) initCategorySwiper();
  });

  // ===== REVEAL ON SCROLL =====
  const reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    const revealObs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          revealObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    reveals.forEach(el => revealObs.observe(el));
  } else {
    reveals.forEach(el => el.classList.add('is-visible'));
  }

  // ===== PROMO POPUP =====
  const promoOverlay = document.getElementById('promo-overlay');
  const promoClose = document.getElementById('promo-close');
  const promoDecline = document.getElementById('promo-decline');
  const promoForm = document.getElementById('promo-form');

  function dismissPromo() {
    if (promoOverlay) promoOverlay.classList.remove('active');
    try { sessionStorage.setItem('amato_promo_seen', '1'); } catch(e) {}
  }

  if (promoOverlay) {
    try {
      if (!sessionStorage.getItem('amato_promo_seen')) {
        setTimeout(() => promoOverlay.classList.add('active'), 2500);
      }
    } catch(e) {
      setTimeout(() => promoOverlay.classList.add('active'), 2500);
    }
    promoOverlay.addEventListener('click', function(e) {
      if (e.target === promoOverlay) dismissPromo();
    });
  }
  promoClose && promoClose.addEventListener('click', dismissPromo);
  promoDecline && promoDecline.addEventListener('click', dismissPromo);

  if (promoForm) {
    promoForm.addEventListener('submit', function(e) {
      e.preventDefault();
      const emailInput = promoForm.querySelector('input[type="email"]');
      if (!emailInput || !emailInput.value) return;

      // Submit to Shopify contact form
      const formData = new FormData();
      formData.append('form_type', 'customer');
      formData.append('contact[accepts_marketing]', 'true');
      formData.append('contact[email]', emailInput.value);
      formData.append('contact[tags]', 'promo-popup');
      formData.append('utf8', '✓');

      fetch('/contact', { method: 'POST', body: formData })
        .catch(() => {});

      promoForm.innerHTML = '<div style="padding:16px 0;text-align:center"><p style="color:#fff;font-weight:700;margin-bottom:8px">Welcome to Amato.</p><p style="color:#888;font-size:14px">Check your inbox for your discount code.</p></div>';
      setTimeout(dismissPromo, 2000);
    });
  }

  // ===== SELL TO US FORM (WhatsApp redirect) =====
  const sellForm = document.getElementById('sell-form');
  if (sellForm) {
    sellForm.addEventListener('submit', function(e) {
      e.preventDefault();
      const name = sellForm.querySelector('[name="sell_name"]')?.value || '';
      const brand = sellForm.querySelector('[name="sell_brand"]')?.value || '';
      const condition = sellForm.querySelector('[name="sell_condition"]')?.value || '';
      const size = sellForm.querySelector('[name="sell_size"]')?.value || '';
      const msg = sellForm.querySelector('[name="sell_message"]')?.value || '';

      const text = `Hi, I'd like to sell to Amato Attire.\n\nName: ${name}\nBrand: ${brand}\nCondition: ${condition}\nSize: ${size}\nDetails: ${msg}`;
      window.open('https://wa.me/447700000000?text=' + encodeURIComponent(text), '_blank');
    });
  }

  // ===== SOURCE ON REQUEST FORM (WhatsApp redirect) =====
  const sourceForm = document.getElementById('source-form');
  if (sourceForm) {
    sourceForm.addEventListener('submit', function(e) {
      e.preventDefault();
      const item = sourceForm.querySelector('[name="source_item"]')?.value || '';
      const size = sourceForm.querySelector('[name="source_size"]')?.value || '';
      const email = sourceForm.querySelector('[name="source_email"]')?.value || '';

      const text = `Hi, I'd like to source a piece from Amato Attire.\n\nItem: ${item}\nSize: ${size}\nEmail: ${email}`;
      window.open('https://wa.me/447700000000?text=' + encodeURIComponent(text), '_blank');
    });
  }

  // ===== CART COUNT UPDATE =====
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(data => {
        const countEl = document.getElementById('cart-count');
        if (countEl) countEl.textContent = data.item_count;
      })
      .catch(() => {});
  }

})();
